module.exports = __webpack_public_path__ + "static/media/wk.4d04c159.svg";